export default {"src":"/_next/static/media/clap.530bee65.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};